(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vue-tiny-slider", [], factory);
	else if(typeof exports === 'object')
		exports["vue-tiny-slider"] = factory();
	else
		root["vue-tiny-slider"] = factory();
})(window, function() {
return 